import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_CALL_STICKY_COLUMNS,
  UPDATE_CALL_STICKY_COLUMNS,
} from "./actionTypes"

import {
  getCallStickyColumnsSuccess,
  getCallStickyColumnsError,
  updateCallStickyColumnsSuccess,
  updateCallStickyColumnsError
} from "./actions"

import { genericGetRequest, genericPutRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"

function* ongetCallStickyColumns() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_column_preference_calls`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'Content-Type': 'application/json'
      }
    )
    yield put(getCallStickyColumnsSuccess(response))
  } catch (error) {
    yield put(getCallStickyColumnsError(error))
  }
}

function* onupdateCallStickyColumns(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_column_preference_calls/${action?.payload?.user_column_preference_call?.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateCallStickyColumnsSuccess(response))
  } catch (error) {
    yield put(updateCallStickyColumnsError(error))
  }
}

function* userCallColumnPreferenceSaga() {
  yield takeEvery(GET_CALL_STICKY_COLUMNS, ongetCallStickyColumns)
  yield takeEvery(UPDATE_CALL_STICKY_COLUMNS, onupdateCallStickyColumns)
}

export default userCallColumnPreferenceSaga;
